import React = require("react");
import { Library } from "..";
import { isActivePath } from "../../../Shared/utils/browser";
import { Link } from "../../custom_components/components/library/link";

const getMenuIcon = (menuItem: string) => {
  if (menuItem == 'Doen') return 'calendar';
  if (menuItem == 'Leren') return 'award';
  if (menuItem == 'Lezen') return 'book';
  if (menuItem == 'Ontmoeten') return 'coffee';
  if (menuItem == 'Word lid') return 'user';
  if (menuItem == 'Vragen') return 'vragen';
  return 'search';
}

const menuLink: Library['menuLink'] = (x, handle) => x.external ? (
  <a
    key={x.key}
    className={`menu__link link--iconed ${isActivePath(x.relative) ? 'menu__link--active' : ''}`}
    href={x.absolute}
    target="_blank"
    rel="noopener noreferrer"
    onClick={handle}
  >
    {x.title}
    <svg className="link__icon" width="24px" height="24px" aria-hidden="true"><use xlinkHref={`#icon--menu-${getMenuIcon(x.title)}`} /></svg>
  </a>
) : (
  <Link key={x.key} url={x.relative} handle={handle} className={`menu__link link--iconed ${isActivePath(x.relative) ? 'menu__link--active' : ''}`}>
    {x.title}
    <svg className="link__icon" width="24px" height="24px" aria-hidden="true"><use xlinkHref={`#icon--menu-${getMenuIcon(x.title)}`} /></svg>
  </Link>
)

export default menuLink